//Generated File 
export default class ApplicationVersion{
	static readonly BUILD_DAY = 7;
	static readonly BUILD_HOUR = 21;
	static readonly BUILD_MINUTE = 59;
	static readonly BUILD_MONTH = 7;
	static readonly BUILD_YEAR = 2026;
	static readonly DATABASE_VERSION = 148;
	static readonly SERVER_VERSION = 7;
}
